import { IBodyTransferDto, IBodyUserDto, IOwnersResponse, ISuppliersResponse, ITransferResponse, IUserDetailResponse, IUsersResponse } from "../interfaces/user";
import authBaseAxios from "../utils/api";

export const UserServices = {
  getMe: () => {
    return authBaseAxios.get("users/user-info");
  },

  getAll: (params?: any): Promise<IUsersResponse> => {
    return authBaseAxios.get("users", params);
  },

  delete: (userId: number): Promise<void> => {
    return authBaseAxios.delete(`users/${userId}`);
  },

  createUser: (body: IBodyUserDto): Promise<IUserDetailResponse> => {
    return authBaseAxios.post("users", body);
  },

  updateUser: (id: number, body: IBodyUserDto): Promise<IUserDetailResponse> => {
    return authBaseAxios.put(`users/${id}`, body);
  },

  getBasic: () => {
    return authBaseAxios.get("users/basic");
  },
  getListSupplierByUser: (userId: number): Promise<ISuppliersResponse> => {
    return authBaseAxios.get(`users/suppliers/${userId}`);
  },
  getListOwner: (userId: number): Promise<IOwnersResponse> => {
    return authBaseAxios.get(`users/owners/${userId}`);
  },
  transferSupplier: (body: IBodyTransferDto): Promise<ITransferResponse> => {
    return authBaseAxios.post("users/transfer", body);
  },
};
